import { reactive, ref, onMounted } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-66865860"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "revenue-header"
};
const _hoisted_2 = {
  class: "filter-content"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = {
  class: "time-content"
};
const _hoisted_5 = {
  class: "time-select-content"
};
const _hoisted_6 = {
  key: 0,
  class: "filter-list"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "time-title"
}, "时间段", -1));
const _hoisted_8 = {
  key: 1,
  class: "filter-list"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "time-title"
}, "时间段", -1));
const _hoisted_10 = {
  class: "condition-content"
};
const _hoisted_11 = {
  class: "condition-select-content"
};
const _hoisted_12 = {
  class: "filter-list"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "产品名", -1));
const _hoisted_14 = {
  class: "appListPopover-content"
};
const _hoisted_15 = {
  class: "appListPopover-content-title"
};
const _hoisted_16 = {
  class: "inf-label"
};
const _hoisted_17 = {
  class: "inf-value"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制", -1));
const _hoisted_19 = {
  class: "filter-list"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "渠道", -1));
const _hoisted_21 = {
  class: "right"
};
import dayjs from 'dayjs';
import DbtDatePicker from '@/components/DbtDatePicker.vue';
import { awaitWrap, getNode, OK, detailFields, searchFields, getAppListInformation, copy } from '@/common';
import { queryGoodsOption } from '@/api/goodsSetting';
import { getPayChnlByDbtIds } from '@/api/thirdParty';
import { ProductSelect } from '@dbt/product-select';
import '@dbt/product-select/dist/style.css';
export default /*#__PURE__*/_defineComponent({
  __name: 'ThirdPartyHeader',
  emits: ['returnSearch', 'resetDimension'],
  setup(__props, {
    emit
  }) {
    const periodList = [{
      label: '天',
      value: 'day'
    },
    // { label: '周', value: 'week' }, 暂时隐藏 2025-7-31
    {
      label: '月',
      value: 'month'
    }, {
      label: '总计',
      value: 'sum'
    }];
    const formState = reactive({
      startTime: dayjs(new Date().getTime() - 7 * 24 * 3600 * 1000).format('YYYYMMDD'),
      endTime: dayjs(new Date().getTime() - 24 * 3600 * 1000).format('YYYYMMDD'),
      recentDay: '7-1',
      dynamic: 0,
      fromDayToDay: 0,
      useServerTime: false // true 开启服务器时间
    });
    const appList = ref([]);
    const channelList = ref([]);
    const datePeriod = ref('day');
    const dbtIdList = ref([]);
    const chnl = ref([]);
    const activeKey = ref('1');
    const monthDate = ref('');
    const productSelectRef = ref(null);
    const chanlSelectRef = ref(null);
    const returnChnl = arr => {
      chnl.value = arr;
    };
    const resetSearch = () => {
      datePeriod.value = 'day';
      chnl.value = [];
      dbtIdList.value = [];
      monthDate.value = dayjs().subtract(1, 'month');
      Object.assign(formState, {
        startTime: dayjs(new Date().getTime() - 7 * 24 * 3600 * 1000).format('YYYYMMDD'),
        endTime: dayjs(new Date().getTime() - 24 * 3600 * 1000).format('YYYYMMDD'),
        recentDay: '7-1',
        dynamic: 0,
        fromDayToDay: 0,
        useServerTime: false // true 开启服务器时间
      });
      getAppData();
      search();
    };
    const handleTime = time => {
      const year = time.substring(0, 4);
      const month = time.substring(4, 6);
      const day = time.substring(6, 8);
      const date = new Date(year, month - 1, day);
      return date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0');
    };
    const search = () => {
      let searchObj = {
        dbtIds: dbtIdList.value,
        payChnls: chnl.value
      };
      if (activeKey.value === '1') {
        searchObj = {
          ...searchObj,
          billType: 'day',
          datePeriod: datePeriod.value,
          startDate: handleTime(formState.startTime),
          endDate: handleTime(formState.endTime)
        };
      } else {
        searchObj = {
          ...searchObj,
          billType: 'month',
          startDate: dayjs(monthDate.value).format('YYYY-MM')
        };
      }
      emit('returnSearch', searchObj);
    };
    const getAppData = async () => {
      try {
        const [err, data] = await awaitWrap(queryGoodsOption());
        if (data && data.code === OK) {
          var _data$data, _productSelectRef$val;
          appList.value = (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.map(item => {
            var _item$extData;
            return {
              label: item.appName,
              value: item.dbtId,
              ...item.extData,
              extData: item.extData,
              filePath: ((_item$extData = item.extData) === null || _item$extData === void 0 ? void 0 : _item$extData.filePath) || '-'
            };
          });
          (_productSelectRef$val = productSelectRef.value) === null || _productSelectRef$val === void 0 || _productSelectRef$val.initializeOptions(appList.value);
        }
        if (err) {}
      } catch (error) {}
      search();
    };
    const getChnlList = async () => {
      if (!dbtIdList.value.length) {
        return channelList.value = [];
      }
      const [err, data] = await awaitWrap(getPayChnlByDbtIds({
        dbtIds: dbtIdList.value
      }));
      if (data && data.code === OK) {
        var _data$data2, _chanlSelectRef$value;
        channelList.value = (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.map(item => {
          return {
            label: item.payChnlName,
            value: item.payChnl
          };
        });
        (_chanlSelectRef$value = chanlSelectRef.value) === null || _chanlSelectRef$value === void 0 || _chanlSelectRef$value.initializeOptions(channelList.value);
      }
      if (err) {}
    };
    const changeType = () => {
      datePeriod.value = 'day';
      chnl.value = [];
      dbtIdList.value = [];
      monthDate.value = dayjs().subtract(1, 'month');
      Object.assign(formState, {
        startTime: dayjs(new Date().getTime() - 7 * 24 * 3600 * 1000).format('YYYYMMDD'),
        endTime: dayjs(new Date().getTime() - 24 * 3600 * 1000).format('YYYYMMDD'),
        recentDay: '7-1',
        dynamic: 0,
        fromDayToDay: 0,
        useServerTime: false // true 开启服务器时间
      });
      getAppData();
      emit('resetDimension', activeKey.value);
    };
    onMounted(() => {
      getAppData();
    });
    return (_ctx, _cache) => {
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_tabs = _resolveComponent("a-tabs");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_date_picker = _resolveComponent("a-date-picker");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_SvgIcon = _resolveComponent("SvgIcon");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_tabs, {
        activeKey: activeKey.value,
        "onUpdate:activeKey": _cache[0] || (_cache[0] = $event => activeKey.value = $event),
        onChange: changeType
      }, {
        default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
          key: "1",
          tab: "每日流水"
        }), _createVNode(_component_a_tab_pane, {
          key: "2",
          tab: "每月账单"
        })]),
        _: 1
      }, 8, ["activeKey"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [activeKey.value === '1' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_hoisted_7, _createVNode(DbtDatePicker, {
        "show-use-server-time": false,
        "show-header": false,
        "show-dynamic": false,
        startTime: formState.startTime,
        "onUpdate:startTime": _cache[1] || (_cache[1] = $event => formState.startTime = $event),
        endTime: formState.endTime,
        "onUpdate:endTime": _cache[2] || (_cache[2] = $event => formState.endTime = $event),
        recentDay: formState.recentDay,
        "onUpdate:recentDay": _cache[3] || (_cache[3] = $event => formState.recentDay = $event),
        dynamic: formState.dynamic,
        "onUpdate:dynamic": _cache[4] || (_cache[4] = $event => formState.dynamic = $event),
        fromDayToDay: formState.fromDayToDay,
        "onUpdate:fromDayToDay": _cache[5] || (_cache[5] = $event => formState.fromDayToDay = $event),
        useServerTime: formState.useServerTime,
        "onUpdate:useServerTime": _cache[6] || (_cache[6] = $event => formState.useServerTime = $event),
        position: "bottomLeft"
      }, null, 8, ["startTime", "endTime", "recentDay", "dynamic", "fromDayToDay", "useServerTime"]), _createVNode(_component_a_select, {
        class: "time-period",
        placeholder: "请选择时间周期",
        options: periodList,
        value: datePeriod.value,
        "onUpdate:value": _cache[7] || (_cache[7] = $event => datePeriod.value = $event),
        getPopupContainer: _unref(getNode)
      }, null, 8, ["value", "getPopupContainer"])])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_hoisted_9, _createVNode(_component_a_date_picker, {
        "allow-clear": false,
        placeholder: "选择月份",
        picker: "month",
        onChange: search,
        value: monthDate.value,
        "onUpdate:value": _cache[8] || (_cache[8] = $event => monthDate.value = $event)
      }, null, 8, ["value"]), _createVNode(_component_a_tooltip, null, {
        title: _withCtx(() => [_createTextVNode("ios渠道按苹果财务月历（非自然月）提供每月账单")]),
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "questionMark",
          "class-name": "mark-icon"
        })]),
        _: 1
      })]))])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_hoisted_13, _createVNode(_unref(ProductSelect), {
        ref_key: "productSelectRef",
        ref: productSelectRef,
        modelValue: dbtIdList.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => dbtIdList.value = $event),
        multiple: true,
        "show-select-all": true,
        "show-extra": true,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": true,
        layout: "vertical",
        descriptionField: "filePath",
        width: "100%",
        customClassName: "revenue-product-label",
        "popup-class-name": "vertical-product-select",
        placeholder: "请选择",
        detailFields: _unref(detailFields),
        onChange: getChnlList,
        "show-bottom-border": ""
      }, {
        detail: _withCtx(({
          detail
        }) => [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_SvgIcon, {
          iconClass: "informationIcon",
          class: "informationIcon"
        }), _createTextVNode(" " + _toDisplayString(detail.label), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAppListInformation)(detail.extData), child => {
          return _openBlock(), _createElementBlock("div", {
            key: child.label,
            class: "inf-line"
          }, [_createElementVNode("div", _hoisted_16, _toDisplayString(child.label) + "：", 1), _createElementVNode("div", _hoisted_17, _toDisplayString(child.value), 1), _createVNode(_component_a_tooltip, {
            placement: "top"
          }, {
            title: _withCtx(() => [_hoisted_18]),
            default: _withCtx(() => [_createVNode(_component_SvgIcon, {
              iconClass: "copy",
              class: "dbt-copyIcon",
              onClick: $event => _unref(copy)(child.value)
            }, null, 8, ["onClick"])]),
            _: 2
          }, 1024)]);
        }), 128))])]),
        _: 1
      }, 8, ["modelValue", "search-fields", "detailFields"])]), _createElementVNode("div", _hoisted_19, [_hoisted_20, _createVNode(_unref(ProductSelect), {
        ref_key: "chanlSelectRef",
        ref: chanlSelectRef,
        modelValue: chnl.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => chnl.value = $event),
        multiple: true,
        "show-select-all": true,
        "show-extra": false,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": false,
        layout: "horizontal",
        width: "100%",
        customClassName: "revenue-product-label",
        "popup-class-name": "revenue-product-select",
        placeholder: "请选择",
        onChange: returnChnl
      }, null, 8, ["modelValue", "search-fields"])])])])]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_a_button, {
        onClick: resetSearch
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }), _createVNode(_component_a_button, {
        type: "primary",
        onClick: search
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      })])])]);
    };
  }
});